<template>
	<BModal id="modal-endereco" centered :title="`Endereço ${enderecoStore.modal.tipoEndereco}`" size="lg"
		v-model="enderecoStore.modal.aberto" @hidden="enderecoStore.fecharModalEndereco" @shown="criarMapa">
		<template #default>
			<div class="row" style="height:170px;">
				<div class="col-12">
					<MapaEnderecoAtendimento ref="mapaLocalizacaoRef" :coordenadas="enderecoStore.coordenadasMapa" />
				</div>
			</div>

			<div class="row">
				<div class="col-12 lh-18 mt-2" v-html="enderecoFormatado" />
			</div>
			
			<div class="row" v-if="!enderecoStore.modal.segundaSaida">
				<div class="col-12 justify-content-md-center mt-3">
					<div sm="12" v-show="geolocationSupported">
						<button class="btn btn-success w-100" :disabled="enderecoStore.loading"
							@click="getCurrentLocation">
							<i class="fas fa-map-marker-alt"></i>
							{{ enderecoStore.loading ? 'Aguarde...' : 'Usar minha localização' }}
						</button>
					</div>
				</div>
			</div>
		</template>

		<template #footer>
			<button type="button" class="btn btn-default" @click="enderecoStore.fecharModalEndereco">
				<span class="material-symbols-outlined">close</span> Fechar
			</button>
			<button type="button" class="btn btn-primary" v-if="!enderecoStore.modal.segundaSaida"
				:disabled="enderecoStore.loading" @click="salvarEndereco">
				<span class="material-symbols-outlined">check</span>
				{{ enderecoStore.loading ? 'Aguarde...' : 'Salvar' }}
			</button>
		</template>
	</BModal>
</template>

<script setup>
import MapaEnderecoAtendimento from "@/components/Mapa/MapaEnderecoAtendimento";
import { computed, ref, nextTick } from 'vue';
import { useAtendimentoStore } from '@/stores/atendimento';
import { useEnderecoStore } from '@/stores/localizacao';
import { isEmpty, montarEndereco } from '@/helper/funcoes';
import { toast, alert } from '@/helper/alerts';

const atendimentoStore = useAtendimentoStore();
const enderecoStore = useEnderecoStore();
const geolocationSupported = 'geolocation' in navigator;
const mapaLocalizacaoRef = ref(null);

function criarMapa() {
	nextTick(() => {
		setTimeout(() => {
			mapaLocalizacaoRef.value?.invalidateSize();
			mapaLocalizacaoRef.value?.invalidateSize();
		}, 100);
	});
}

const enderecoFormatado = computed(() => {
	return montarEndereco(enderecoStore.dadosEndereco);
});

async function getCurrentLocation() {
	try {
		await enderecoStore.obterLocalizacaoAtual();
		toast("success", `Localização de ${enderecoStore.modal.tipoEndereco} recuperada com sucesso.`);
	} catch (error) {
		alert("error", "", error.message);
	}
}

async function salvarEndereco() {
	try {
		enderecoStore.loading = true;
		let vazio = 0;
		for (const key in enderecoStore.dadosEndereco) {
			if (Object.prototype.hasOwnProperty.call(enderecoStore.dadosEndereco, key)) {
				const campo = enderecoStore.dadosEndereco[key];
				if (isEmpty(campo)) {
					vazio++;	
				}
			}
		}

		if (vazio == Object.keys(enderecoStore.dadosEndereco).length) {
			alert("warning", "", 'O endereço está vazio');
			enderecoStore.loading = false;
		} else {
			const response = await atendimentoStore.salvarEndereco(enderecoStore.modal.tipoEndereco, enderecoStore.dadosEndereco);
			if (response.error) {
				alert("error", "", response.message);
			} else {
				toast("success", response.message);
			}
			enderecoStore.fecharModalEndereco();
		}
	} catch (error) {
		alert("error", "", error.message);
	} finally {
		enderecoStore.loading = false;
	}
}
</script>